<div class="container embedded-report">
  <ngx-powerbi-component *ngIf="tokenInfo" type="qna"
    [id]="txtEmbedReportId" [embedUrl]="url" tokenType="Embed" [accessToken]="tokenInfo ">
  </ngx-powerbi-component>
</div>
<!-- <iframe width="1140" height="541.25"
  src="https://app.powerbi.com/reportEmbed?reportId=d2d1e9ed-691f-44c7-bee5-3b4dfd749a02&autoAuth=true&ctid=54c70f61-fcb4-416a-821d-2c1defe4860f&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYy1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
  frameborder="0" allowFullScreen="true"></iframe> -->
